import {
  GET_TILL_LIMITS,
  GET_TILL_LIMITS_COMPLETED,
  GET_TILL_LIMITS_FAILED,
  SET_TILL_LIMIT,
  SET_TILL_LIMIT_COMPLETED,
  SET_TILL_LIMIT_FAILED,
} from './actions';
import {firstPage, getPaginationOrDefault} from "../utils/pagination";
import {AUTH_LOGOUT} from "../Auth/actions";

const defaultState = {
  tillLimitsLoading: false,
  tillLimits: [],
  tillLimitsPagination: firstPage,
  tillLimitsError: null
};

const tillLimitReducer = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case GET_TILL_LIMITS: {
      const tillLimitsLoading = true;
      return {
        ...state,
        tillLimitsLoading
      };
    }
    case GET_TILL_LIMITS_COMPLETED: {
      const tillLimitsLoading = false;
      const tillLimits = action.payload.data;
      const tillLimitsPagination = getPaginationOrDefault(action.payload);
      return {
        ...state,
        tillLimitsLoading,
        tillLimits,
        tillLimitsPagination,
      };
    }
    case GET_TILL_LIMITS_FAILED: {
      const tillLimitsLoading = false;
      const tillLimitsError = action.payload;
      return {
        ...state,
        tillLimitsLoading,
        tillLimitsError
      };
    }
    case SET_TILL_LIMIT:
      return state;
    case SET_TILL_LIMIT_COMPLETED:
      return state;
    case SET_TILL_LIMIT_FAILED:
      return state;
    case AUTH_LOGOUT: {
      return defaultState;
    }
    default:
      return state;
  }
};

export default tillLimitReducer;



// WEBPACK FOOTER //
// ./src/TillLimit/reducer.js